var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 14", width: "20", height: "20" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_etc"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_information" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icon_etc" },
            React.createElement("path", { id: "line_etc1", className: styles["cls-1"] || "cls-1", d: "M0 0h20v2H0z" }),
            React.createElement("path", { id: "line_etc2", className: styles["cls-1"] || "cls-1", d: "M0 6h20v2H0z" }),
            React.createElement("path", { id: "line_etc3", className: styles["cls-1"] || "cls-1", d: "M0 12h20v2H0z" })
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/molecules/header/images/etc.svg
// module id = 607
// module chunks = 0